const setIsEligibleForOffers = (state, isEligibleForOffers) => {
  state.isEligibleForOffers = isEligibleForOffers;
};

const setLegacyUser = (state, legacyUser) => {
  state.legacyUser = legacyUser;
};

const setSaveError = (state, error) => {
  state.saveError = error;
};

const setSaveLoading = (state, loading) => {
  state.saveLoading = loading;
};

const setUser = (state, user) => {
  state.isAuthenticated = true;
  state.currentUser = user;
  state.currentCustomer = user;
  state.errors = {};
};

const setUserJwt = (state, jwt) => {
  state.userJwt = jwt;
};

const getAccountLastModified = (state, response) => {
  state.AccountLastModified = response;
};

export default {
  setIsEligibleForOffers,
  setLegacyUser,
  setSaveError,
  setSaveLoading,
  setUser,
  setUserJwt,
  getAccountLastModified,
};
